import { NgbTransitionStartFn } from './_ngb-ngbootstrap-utilities.mjs';

export const ngbAlertFadingTransition: NgbTransitionStartFn = ({ classList }: HTMLElement) => {
	classList.remove('show');
};
